import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';
import './css/board.css';

export default class hattyuu_or_ship_check extends Component{
    state={
    }
  
    constructor(props) {
      super(props);
      this.state = { 
				checked: false,
			};
    }
  
    componentDidMount () {
    }
  
  
    openModal = () => this.setState({ isOpen: true });
    closeModal = () => this.setState({ isOpen: false });
  
  
    handleChange = (e) => {
			//console.dir(e);
      this.setState({ checked: !this.state.checked });
      //console.log(!this.state.checked );
			this.props.changeBordMode(!this.state.checked);
    }
  
    render(){
      //console.log(this.state.checked);

      return (
        <>
					<div className="container">
					  <div className="row">
              <div className="d-flex board-1-switch">
                <div className={ this.state.checked ? 'radio-board-label-off' : 'radio-board-label-on' }>発注</div>
                <Switch
                  className="mx-2"
                  checked={this.state.checked}
                  onChange={this.handleChange}
                />
                <div className={ this.state.checked ? 'radio-board-label-on' : 'radio-board-label-off' }>出荷確認</div>
      				</div>
					  </div>
					</div>
        </>
      );
    }
  }
  
  

	//{...this.props}